export const item = (currentPath, itemPath) =>
  currentPath === itemPath ? { active: true } : {};
